import type { ReactNode } from 'react';
import type {
  IdlePopupStorageKeys,
  IdlePopupTracking,
} from 'hooks/popup/constants';
import type {
  LocationMatchMethod,
  LocationMatchTarget,
} from 'utils/locationMatch';

/**
 * Bangalore "Come try it on" is off.
 * Set this to true to show it again for Ring AIR visitors in Bengaluru.
 */
export const BANGALORE_TRY_ON_ENABLED = false;

export type BangaloreTryOnPopupProps = {
  /** Rendered instead when the popup is off or the visitor is not in Bengaluru. */
  fallback: ReactNode;
  delayMs?: number;
  region?: string;
};

export type BangaloreTryOnCardProps = Omit<
  BangaloreTryOnPopupProps,
  'fallback'
> & {
  matchMethod: LocationMatchMethod;
};

export const BANGALORE_EXPERIENCE_CENTRE = {
  latitude: 12.9635736,
  longitude: 77.6414554,
  imageSrc: 'web_v2/ring-buy/PL-15.jpg',
  mapsUrl: 'https://maps.app.goo.gl/KD7Z34GSK4JGpKvx5',
} as const;

export const BANGALORE_CITY_ALIASES = [
  'BANGALORE',
  'BENGALURU',
  'BANGALORE URBAN',
  'BENGALURU URBAN',
] as const;

export const BANGALORE_LOCATION_TARGET: LocationMatchTarget = {
  cityAliases: BANGALORE_CITY_ALIASES,
  latitude: 12.9716,
  longitude: 77.5946,
  radiusKm: 60,
  browserGeoCountries: ['IN'],
};

export const buildUberDeeplinkUrl = (
  latitude: number | string,
  longitude: number | string,
): string =>
  `https://m.uber.com/ul/?action=setPickup&dropoff[latitude]=${latitude}&dropoff[longitude]=${longitude}`;

export const BANGALORE_UBER_DEEPLINK = buildUberDeeplinkUrl(
  BANGALORE_EXPERIENCE_CENTRE.latitude,
  BANGALORE_EXPERIENCE_CENTRE.longitude,
);

export const BANGALORE_TRY_ON_STORAGE_KEYS: IdlePopupStorageKeys = {
  dismissed: 'UH_bangalore-try-on-popup-dismissed',
  completed: 'UH_bangalore-try-on-popup-completed',
};

export const BANGALORE_TRY_ON_TRACKING: IdlePopupTracking = {
  analytics: {
    TIMER_STARTED: 'bangalore_try_on_popup_timer_started',
    SUPPRESSED: 'bangalore_try_on_popup_suppressed',
    POPUP_SHOWN: 'bangalore_try_on_popup_shown',
    POPUP_DISMISSED: 'bangalore_try_on_popup_dismissed',
    COMPLETED: 'bangalore_try_on_popup_completed',
    CANCELLED: 'bangalore_try_on_popup_cancelled',
  },
  gtm: {
    TIMER_STARTED: 'bangaloreTryOnPopupTimerStarted',
    SUPPRESSED: 'bangaloreTryOnPopupSuppressed',
    POPUP_SHOWN: 'bangaloreTryOnPopupShown',
    POPUP_DISMISSED: 'bangaloreTryOnPopupDismissed',
    COMPLETED: 'bangaloreTryOnPopupCompleted',
    CANCELLED: 'bangaloreTryOnPopupCancelled',
  },
};
